async function importOrReload(dynamicImportFn: () => Promise<any>) {
  try {
    return await dynamicImportFn()
  } catch (_e) {
    window.location.reload()
  }
}

export { importOrReload }
